import * as z from "zod";

export const requestSignupOtp = {
  name: "requestSignupOtp" as const,
  input: z.object({ email: z.email() }),
  output: z.object({ success: z.boolean(), otpId: z.string().optional() }),
};
